import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PhotoAlbum, PhotoAlbumWithItems } from '../../types/photoAlbum';

export interface PhotoAlbumState {
  albumMap: Record<number, PhotoAlbum[]>;
  albumDetailsMap: Record<string, PhotoAlbumWithItems>;
}

const initialState: PhotoAlbumState = {
  albumMap: {},
  albumDetailsMap: {},
};

const photoAlbumSlice = createSlice({
  name: 'photoAlbum',
  initialState,
  reducers: {
    setAlbums(state, action: PayloadAction<{ communityId: number; albums: PhotoAlbum[] }>): void {
      const { communityId, albums } = action.payload;
      state.albumMap[communityId] = albums;
    },

    setAlbumDetails(state, action: PayloadAction<{ albumId: string; album: PhotoAlbumWithItems }>): void {
      const { albumId, album } = action.payload;
      state.albumDetailsMap[albumId] = album;
    },

    addAlbum(state, action: PayloadAction<{ communityId: number; album: PhotoAlbum }>): void {
      const { communityId, album } = action.payload;
      if (!state.albumMap[communityId]) {
        state.albumMap[communityId] = [];
      }
      state.albumMap[communityId].push(album);
    },

    updateAlbum(state, action: PayloadAction<{ communityId: number; album: PhotoAlbum }>): void {
      const { communityId, album } = action.payload;
      if (state.albumMap[communityId]) {
        state.albumMap[communityId] = state.albumMap[communityId].map((a) => (a.id === album.id ? album : a));
      }
    },

    deleteAlbum(state, action: PayloadAction<{ communityId: number; albumId: string }>): void {
      const { communityId, albumId } = action.payload;
      if (state.albumMap[communityId]) {
        state.albumMap[communityId] = state.albumMap[communityId].filter((a) => a.id !== albumId);
      }
      delete state.albumDetailsMap[albumId];
    },
  },
});

export const { setAlbums, setAlbumDetails, addAlbum, updateAlbum, deleteAlbum } = photoAlbumSlice.actions;
const photoAlbumReducer = photoAlbumSlice.reducer;
export default photoAlbumReducer;
